module.exports = __webpack_public_path__ + "media/form-type-page/clock-819298c7.svg";